import { createFileRoute, Navigate } from '@tanstack/react-router';
import { Forbidden } from '@/components/shared/page-states';
import {
  BOXES_PAGE_SERVICES,
  TREASURY_PAGE_SERVICES,
  useCan,
  useCanAny,
} from '@/features/auth/session';

export function DashboardLanding(): React.JSX.Element {
  const canBoxes = useCanAny(BOXES_PAGE_SERVICES);
  const canCurrencies = useCan('CURRENCY_LIST');
  const canTreasury = useCanAny(TREASURY_PAGE_SERVICES);
  const canReports = useCan('REPORT_VIEW');
  const canUsers = useCan('USER_LIST');
  const canGroups = useCan('GROUP_LIST');

  if (canBoxes) return <Navigate to="/boxes" replace />;
  if (canCurrencies) return <Navigate to="/currencies" replace />;
  if (canTreasury) return <Navigate to="/treasury" replace />;
  if (canReports) return <Navigate to="/reports" replace />;
  if (canUsers) return <Navigate to="/settings/users" replace />;
  if (canGroups) return <Navigate to="/settings/groups" replace />;
  return <Forbidden />;
}

export const Route = createFileRoute('/_app/')({
  component: DashboardLanding,
});
